export enum Scopes {
  Openid = "openid",
  EscalationsRead = "blackboard.escalations.read",
  EscalationsManage = "blackboard.escalations.manage",
  ReviewsRead = "blackboard.reviews.read",
  ReviewsManage = "blackboard.reviews.manage",
  GroupsRead = "blackboard.groups.read",
}
